// import css from './blog.module.css'

// import {HandySvg} from 'handy-svg';
// import iconSrc from '../../img/blogTitleAitor.png';
// import arrowImp from '../../img/arrowDownPick.png'
// import you from '../../svg/youVideo.svg'

// export default function BlogTitle() {

//     return(
//         <div className={css.videoTitleWrap}>
//             <div className={css.totalVideoWrap}>
//             <div className={css.firstBlockWrap}>
//                 <h1 className={css.videoViewvH1}>Як залучити дитину до читання змалку?</h1>
//                 <p className={css.videoViewvP}>Олег Симоненко дослідив це питання і допоможе Вам розібратися</p>
//            <button className={css.buttonRead}>Читати</button>

//             </div>
//             <div className={css.secondBlockWrap}>
//             <img
//                     src={iconSrc}
//                     className={css.svgForVideo}

//                     />
//             </div>
//             </div>
//         </div>
//     )
// }
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";

import css from "./blog.module.css";
import fallbackImage from "../../img/blogTitleAitor.png";
import { db } from "../../firebase";

const DEFAULT_BANNER = {
  title: "Як залучити дитину до читання змалку?",
  description: "Олег Симоненко дослідив це питання і допоможе Вам розібратися",
  buttonText: "Читати",
  buttonLink: "/blog",
  imageUrl: "",
};

export default function BlogTitle() {
  const [banner, setBanner] = useState(DEFAULT_BANNER);

  useEffect(() => {
    const bannerRef = doc(db, "settings", "blogBanner");

    const unsubscribe = onSnapshot(
      bannerRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          setBanner(DEFAULT_BANNER);
          return;
        }

        setBanner({
          ...DEFAULT_BANNER,
          ...snapshot.data(),
        });
      },
      (error) => {
        console.error("Помилка завантаження банера блогу:", error);
        setBanner(DEFAULT_BANNER);
      },
    );

    return unsubscribe;
  }, []);

  const imageSrc = banner.imageUrl || fallbackImage;
  const isInternalLink = banner.buttonLink?.startsWith("/");

  const buttonContent = (
    <span className={css.buttonRead}>{banner.buttonText || "Читати"}</span>
  );

  return (
    <section className={css.videoTitleWrap}>
      <div className={css.totalVideoWrap}>
        <div className={css.firstBlockWrap}>
          <h1 className={css.videoViewvH1}>{banner.title}</h1>

          {banner.description && (
            <p className={css.videoViewvP}>{banner.description}</p>
          )}

          {banner.buttonText && banner.buttonLink && (
            <>
              {isInternalLink ? (
                <Link to={banner.buttonLink} className={css.buttonRead}>
                  {buttonContent}
                </Link>
              ) : (
                <a
                  href={banner.buttonLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.buttonRead}
                >
                  {buttonContent}
                </a>
              )}
            </>
          )}
        </div>

        <div className={css.secondBlockWrap}>
          <img
            src={imageSrc}
            className={css.svgForVideo}
            alt={banner.imageAlt || banner.title || "Банер блогу"}
          />
        </div>
      </div>
    </section>
  );
}
